import { render, staticRenderFns } from "./Admissions.vue?vue&type=template&id=a100373e&scoped=true&"
import script from "./Admissions.vue?vue&type=script&lang=js&"
export * from "./Admissions.vue?vue&type=script&lang=js&"
import style0 from "./Admissions.vue?vue&type=style&index=0&id=a100373e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a100373e",
  null
  
)

export default component.exports